<template>
  <!--  数据范围-->
  <div class="range-privilege">
    <div class="header-wrapper">
      <el-button type="text" @click="setCondition">设置自定义条件</el-button>
    </div>
    <el-table
      v-ps="'.el-table__body-wrapper'"
      :data="opTypeList"
      class="setting-list"
      :max-height="screenHeight"
      :header-cell-style="headerStyle"
      :cell-style="{ height: '40px' }"
      :highlight-current-row="false"
    >
      <el-table-column
        prop="field"
        label="操作"
        header-align="center"
        align="center"
        fixed
        width="110px"
      >
        <template slot-scope="scope">
          {{ opTypeNameMap[scope.row] }}
        </template>
      </el-table-column>
      <el-table-column
        v-for="cellGroup in allLevelOptions"
        :key="cellGroup.value"
        :prop="cellGroup.name"
        header-align="center"
        width="158px"
        align="center"
      >
        <!--         eslint-disable-next-line-->
        <template slot="header" slot-scope="scope">
          <el-checkbox
            :value="isAllChecked(cellGroup.value)"
            @change="checkAll(cellGroup.value)"
            :indeterminate="isInterminate(cellGroup.value)"
          >
            {{ cellGroup.name }}
          </el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-radio
            :value="sheetPris[scope.row]"
            :label="cellGroup.value"
            @change="priChange(scope.row, cellGroup.value)"
          >
            {{ "" }}
          </el-radio>
        </template>
      </el-table-column>
    </el-table>
    <condition-setting-dialog
      ref="conditionSettingDialog"
      @closed="refreshConditionList"
    ></condition-setting-dialog>
  </div>
</template>

<script>
import { getExtraPriLevelList } from "@/api/appManage/role"
import { basePrivileges, levelOptions, equalPrivileges } from "~/data/static"
import ConditionSettingDialog from "./ConditionSettingDialog.vue"
export default {
  name: "range-privilege",
  components: {
    ConditionSettingDialog
  },
  props: {
    sheet: Object,
    sheetPris: Object
  },
  data() {
    return {
      extraConditionList: [],
      screenHeight: `${document.documentElement.clientHeight}` - 316,
      headerStyle: {
        color: "#333",
        backgroundColor: "#ededed"
      }
    }
  },
  mounted() {
    const that = this
    window.onresize = function listen() {
      that.screenHeight = `${document.documentElement.clientHeight}` - 316
    }
  },
  computed: {
    opTypeList() {
      let basePriTypeList = basePrivileges
        .filter(pri => pri.name !== "新建") // 新建不需要设置
        .filter(pri => this.sheetPris[pri.value] != "NONE")
        .map(pri => pri.value)
      // 在原来的按钮基础上加上自定义按钮
      let btnTypesList = this.sheet.btns
        .filter(btn => this.sheetPris[btn.id] != "NONE")
        .map(btn => btn.id)
      return basePriTypeList.concat(btnTypesList)
    },
    // 权限的限制条件
    allLevelOptions() {
      // 在原来的条件基础上加上自定义条件
      return levelOptions.concat(
        this.extraConditionList.map(t => ({
          name: t.name,
          value: t.id
        }))
      )
    },
    // 把操作权限的编码转成文字
    opTypeNameMap() {
      let map = {}
      basePrivileges.forEach(item => (map[item.value] = item.name))
      ;(this.sheet?.btns || []).forEach(item => (map[item.id] = item.name))
      return map
    }
  },
  created() {
    this.refreshConditionList()
  },
  methods: {
    refreshConditionList() {
      getExtraPriLevelList(this.sheet.sheetId).then(
        extraConditionList => (this.extraConditionList = extraConditionList)
      )
    },
    isAllChecked(level) {
      // 全选框的值
      return !this.opTypeList.some(type => this.sheetPris[type] !== level)
    },
    // 判断是否isInterminate状态
    isInterminate(level) {
      let count = this.opTypeList.filter(type => this.sheetPris[type] == level).length
      return 0 < count && count < this.opTypeList.length
    },
    checkAll(level) {
      // 应该是所有的行的列那个单元格为TRUE
      // 点击时所有type的level相等的都勾上
      this.opTypeList.forEach(type => {
        this.sheetPris[type] = level
      })
    },
    priChange(type, level) {
      // 如果有需要与当前权限的数据范围保持一致的权限，则将这些权限的数据范围修改与他们保持一致
      this.sheetPris[type] = level
      equalPrivileges
        .map(t => this._.intersection(t, this.opTypeList))
        .forEach(equalPrivilege => {
          if (equalPrivilege.includes(type)) {
            equalPrivilege.forEach(type => (this.sheetPris[type] = level))
          }
        })
    },
    setCondition() {
      this.$refs.conditionSettingDialog.open({
        sheet: this.sheet,
        extraConditionList: this.extraConditionList
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table::before {
    background: none;
  }
  .el-table {
    .el-table__fixed {
      height: auto !important;
      bottom: -17px !important;
    }
  }
}
.range-privilege {
  .header-wrapper {
    display: flex;
    .el-button {
      padding-top: 0;
      margin-left: auto;
    }
  }
  .setting-list {
    position: relative;
  }
}
</style>
